(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift"] && !Shopify.designMode) return;
  try {
    
(function(){
  var s=document.getElementById('section-{{ section.id }}');
  if(!s)return;
  var track=s.querySelector('#giftsTrack-{{ section.id }}');
  var dots=s.querySelectorAll('#giftsDots-{{ section.id }} .czn-gifts__dot');
  var prev=s.querySelector('#giftsPrev-{{ section.id }}');
  var next=s.querySelector('#giftsNext-{{ section.id }}');
  if(!track)return;
  function cards(){return track.querySelectorAll('.czn-gifts__mob-card')}
  function active(){var mid=track.getBoundingClientRect().left+track.offsetWidth/2,best=0,bd=Infinity;cards().forEach(function(c,i){var d=Math.abs(c.getBoundingClientRect().left+c.offsetWidth/2-mid);if(d<bd){bd=d;best=i;}});return best;}
  function go(i){var c=cards()[i];if(!c)return;track.scrollTo({left:c.offsetLeft-(track.offsetWidth/2)+(c.offsetWidth/2),behavior:'smooth'});}
  function ui(){var i=active(),cs=cards();dots.forEach(function(d,j){d.classList.toggle('is-active',j===i);d.setAttribute('aria-selected',j===i?'true':'false');});if(prev)prev.disabled=i===0;if(next)next.disabled=i===cs.length-1;}
  dots.forEach(function(d){d.addEventListener('click',function(){go(parseInt(d.dataset.index,10));});});
  if(prev)prev.addEventListener('click',function(){go(Math.max(0,active()-1));});
  if(next)next.addEventListener('click',function(){go(Math.min(cards().length-1,active()+1));});
  var t;track.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(ui,80);},{passive:true});
  ui();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-age"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.getElementById('section-{{ section.id }}');
  if (!sectionEl) return;

  var track   = sectionEl.querySelector('#sbaTrack-{{ section.id }}');
  var dots    = sectionEl.querySelectorAll('#sbaDots-{{ section.id }} .czn-sba__dot');
  var btnPrev = sectionEl.querySelector('#sbaPrev-{{ section.id }}');
  var btnNext = sectionEl.querySelector('#sbaNext-{{ section.id }}');

  if (!track) return;

  function getSlides() {
    return track.querySelectorAll('.czn-sba__slide');
  }

  function getActiveIndex() {
    var slides   = getSlides();
    var trackMid = track.getBoundingClientRect().left + track.offsetWidth / 2;
    var best = 0, bestDist = Infinity;
    slides.forEach(function(slide, i) {
      var mid  = slide.getBoundingClientRect().left + slide.offsetWidth / 2;
      var dist = Math.abs(mid - trackMid);
      if (dist < bestDist) { bestDist = dist; best = i; }
    });
    return best;
  }

  function scrollToIndex(idx) {
    var slides = getSlides();
    if (!slides[idx]) return;
    var slide    = slides[idx];
    var scrollTo = slide.offsetLeft - (track.offsetWidth / 2) + (slide.offsetWidth / 2);
    track.scrollTo({ left: scrollTo, behavior: 'smooth' });
  }

  function updateUI() {
    var idx    = getActiveIndex();
    var slides = getSlides();
    dots.forEach(function(dot, i) {
      dot.classList.toggle('is-active', i === idx);
      dot.setAttribute('aria-selected', i === idx ? 'true' : 'false');
    });
    if (btnPrev) btnPrev.disabled = idx === 0;
    if (btnNext) btnNext.disabled = idx === slides.length - 1;
  }

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      scrollToIndex(parseInt(dot.dataset.index, 10));
    });
  });

  if (btnPrev) btnPrev.addEventListener('click', function() {
    scrollToIndex(Math.max(0, getActiveIndex() - 1));
  });
  if (btnNext) btnNext.addEventListener('click', function() {
    scrollToIndex(Math.min(getSlides().length - 1, getActiveIndex() + 1));
  });

  var t;
  track.addEventListener('scroll', function() {
    clearTimeout(t);
    t = setTimeout(updateUI, 80);
  }, { passive: true });

  updateUI();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-it-build"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.getElementById('section-{{ section.id }}');
  if (!sectionEl) return;
  var track = sectionEl.querySelector('#wibTrack-{{ section.id }}');
  var dots = sectionEl.querySelectorAll('#wibDots-{{ section.id }} .czn-wib__dot');
  var btnPrev = sectionEl.querySelector('#wibPrev-{{ section.id }}');
  var btnNext = sectionEl.querySelector('#wibNext-{{ section.id }}');
  if (!track) return;
  function getSlides() { return track.querySelectorAll('.czn-wib__slide'); }
  function getActiveIndex() {
    var slides = getSlides(), trackLeft = track.getBoundingClientRect().left, trackMid = trackLeft + track.offsetWidth / 2, best = 0, bestDist = Infinity;
    slides.forEach(function(slide, i) {
      var mid = slide.getBoundingClientRect().left + slide.offsetWidth / 2, dist = Math.abs(mid - trackMid);
      if (dist < bestDist) { bestDist = dist; best = i; }
    });
    return best;
  }
  function scrollToIndex(idx) {
    var slides = getSlides(); if (!slides[idx]) return;
    var slide = slides[idx], scrollTo = slide.offsetLeft - (track.offsetWidth / 2) + (slide.offsetWidth / 2);
    track.scrollTo({ left: scrollTo, behavior: 'smooth' });
  }
  function updateUI() {
    var idx = getActiveIndex(), slides = getSlides();
    dots.forEach(function(dot, i) { dot.classList.toggle('is-active', i === idx); dot.setAttribute('aria-selected', i === idx ? 'true' : 'false'); });
    if (btnPrev) btnPrev.disabled = idx === 0; if (btnNext) btnNext.disabled = idx === slides.length - 1;
  }
  dots.forEach(function(dot) { dot.addEventListener('click', function() { scrollToIndex(parseInt(dot.dataset.index, 10)); }); });
  if (btnPrev) { btnPrev.addEventListener('click', function() { scrollToIndex(Math.max(0, getActiveIndex() - 1)); }); }
  if (btnNext) { btnNext.addEventListener('click', function() { scrollToIndex(Math.min(getSlides().length - 1, getActiveIndex() + 1)); }); }
  var t; track.addEventListener('scroll', function() { clearTimeout(t); t = setTimeout(updateUI, 80); }, { passive: true });
  updateUI();
})();

  } catch(e) { console.error(e); }
})();
})();
